interface OSSImageProcessingOptions {
  resize?: {
    m?:
      | 'lfit'
      | 'mfit'
      | 'fill'
      | 'pad'
      | 'fixed';
    w?: number;
    h?: number;
    l?: number;
    s?: number;
    limit?: 0 | 1;
    color?: string;
  };
}

export const ossImage = (
  url: string | null | undefined,
  options: OSSImageProcessingOptions = {},
) => {
  if (!url) {
    return '';
  }

  const urlObj = new URL(url);
  urlObj.protocol = 'https';
  const param = urlObj.searchParams;

  let imageParams = 'image';
  if (options.resize) {
    imageParams += '/resize';
    options.resize.m && (imageParams += `,m_${options.resize.m}`);
    options.resize.w && (imageParams += `,w_${options.resize.w}`);
    options.resize.h && (imageParams += `,h_${options.resize.h}`);
    options.resize.l && (imageParams += `,l_${options.resize.l}`);
    options.resize.s && (imageParams += `,s_${options.resize.s}`);
    options.resize.limit && (imageParams += `,limit_${options.resize.limit}`);
    options.resize.color && (imageParams += `,color_${options.resize.color}`);
  }

  param.set('x-oss-process', imageParams);
  return urlObj.toString();
};
